import { LinkEditorPanel } from "../../../../components/panels";
import { Icon } from "../../../../components/ui/Icon";
import { Toolbar } from "../../../../components/ui/Toolbar";
import { Popover } from "../../../ui/Popover";

export type EditLinkPopoverProps = {
    onSetLink: (link: string, openInNewTab?: boolean) => void;
    className?: string;
};

export const EditLinkPopover = ({ onSetLink }: EditLinkPopoverProps) => {
    return (
        <Popover content={<LinkEditorPanel onSetLink={onSetLink} />}>
            {({ openPopup }) => (
                <Toolbar.Button tooltip="Set Link" onClick={openPopup}>
                    <Icon name="Link" />
                </Toolbar.Button>
            )}
        </Popover>
    );
};
